import { parseJwt, ParsedToken } from './jwt';

type Listener = (token: string | null) => void;

let accessToken: string | null = null;
let parsed: ParsedToken | null = null;
const listeners = new Set<Listener>();

export const tokenStore = {
  get: () => accessToken,
  getParsed: () => parsed,

  set(token: string | null) {
    const nextParsed = token ? parseJwt(token) : null;
    if (token && !nextParsed) {
      accessToken = null;
      parsed = null;
      listeners.forEach((fn) => fn(null));
      return;
    }
    accessToken = token;
    parsed = nextParsed;
    listeners.forEach((fn) => fn(token));
  },

  clear() {
    accessToken = null;
    parsed = null;
    listeners.forEach((fn) => fn(null));
  },

  isExpired(): boolean {
    if (!parsed) return true;
    const exp = Number(parsed.exp);
    if (!Number.isFinite(exp)) return true;
    return exp * 1000 < Date.now();
  },

  subscribe(fn: Listener): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};

const LEGACY_KEYS = [
  '@VLAB_AUTH_TOKEN',
  '@VLAB_STORAGE_SESSION',
  'TEMP_VLAB_AUTH_TOKEN',
];

function expireCookie(name: string) {
  const expired = 'expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  document.cookie = `${name}=; ${expired}`;
  document.cookie = `${name}=; ${expired} domain=${window.location.hostname};`;
}

export function purgeLegacyAuthArtifacts() {
  LEGACY_KEYS.forEach(expireCookie);
  try {
    LEGACY_KEYS.forEach((k) => {
      localStorage.removeItem(k);
      sessionStorage.removeItem(k);
    });
  } catch {}
}
